import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authApi } from '../../api/services';
import toast from 'react-hot-toast';
export default function RegisterPage() {
  const [form, setForm] = useState({phone:'',firstName:'',lastName:'',password:''});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); setLoading(true);
    try {
      await authApi.register(form);
      toast.success('Kayıt başarılı! OTP kodu gönderildi.');
      navigate('/verify-otp', { state: { phone: form.phone } });
    } catch (err: any) { toast.error(err.response?.data?.error || 'Kayıt başarısız'); }
    finally { setLoading(false); }
  };
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <div className='card' style={{width:'100%',maxWidth:'420px',padding:'40px'}}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:'16px'}}>
          <Link to='/'>
            <img src='/logo-transparent.png' alt='Zavadak' style={{height:'44px',maxWidth:'220px',objectFit:'contain'}} />
          </Link>
        </div>
        <h1 style={{textAlign:'center',marginBottom:'8px'}}>Kayıt Ol</h1>
        <p className='text-muted text-center' style={{marginBottom:'24px'}}>Yeni hesap oluşturun</p>
        <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:'16px'}}>
          <div className='grid-2'>
            <div className='form-group'><label className='form-label'>Ad</label><input className='form-input' value={form.firstName} onChange={e=>setForm({...form,firstName:e.target.value})} required /></div>
            <div className='form-group'><label className='form-label'>Soyad</label><input className='form-input' value={form.lastName} onChange={e=>setForm({...form,lastName:e.target.value})} required /></div>
          </div>
          <div className='form-group'><label className='form-label'>Telefon</label><input className='form-input' type='tel' value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder='05xxxxxxxxx' required /></div>
          <div className='form-group'><label className='form-label'>Şifre</label><input className='form-input' type='password' value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required /></div>
          <button className='btn btn-primary btn-full btn-lg' disabled={loading}>{loading ? '...' : 'Kayıt Ol'}</button>
        </form>
        <p className='text-center text-muted' style={{marginTop:'24px',fontSize:'0.9rem'}}>Hesabınız var mı? <Link to='/login' style={{color:'var(--color-primary)'}}>Giriş Yap</Link></p>
      </div>
    </div>
  );
}
